import logo from './logo.svg';
import './App.css';
import NavigationBar from './component/common/NavigationBar/NavigationBar';
import NavContact from './component/common/NavigationBar/NavContact';
import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Footer from './component/common/Footer';
import Disclaimer from './component/common/Disclaimer';
import Practice from './pages/Practice';
import AboutPage from './pages/AboutPage';
import AdminLogin from './pages/AdminLogin';
import AdminGetAllBlog from './pages/AdminGetAllBlog';
import AdminRoute from './component/AdminRoute';
import ManageBlog from './pages/ManageBlog';

import BlogDetails from "./component/Admin/BlogDetails";
import Blog from './pages/Blog';
import Internship from './pages/Internship';
import Retainership from './pages/Retainership';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './utils/ScrollToTop';
import NotFound from './pages/NotFound';
function App() {
  return (
    <div className=" flex  flex-col justify-center items-center w-full ">
        <Disclaimer/>
        <ScrollToTop/>
         <NavigationBar/>
         <Routes>
          <Route path='/' element={<HomePage/>} />
          <Route path="*" element={<NotFound/>} />
          <Route path='/practice/:title' element={<Practice />} />
          <Route path='/about' element={<AboutPage/>} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/career/internship" element={<Internship />} />
          <Route path="/career/retainership" element={<Retainership />} />
          <Route path="/contact" element={<ContactPage />} />



          <Route path="/blog" element={<Blog />} />


          <Route path="/admin/login" element={<AdminLogin/>} />

            <Route path="/admin/*" element={<AdminRoute />}>
          <Route path="blog/manage-blog" element={<ManageBlog />} />
        </Route>
            <Route path="/admin/blog/getallblog" element={<AdminGetAllBlog />} />
            <Route path="/blog/:id" element={<BlogDetails />} />


         </Routes>
         <Footer/>
    </div>
  );
}

export default App;
